import { Component, AfterViewInit } from '@angular/core';
import {AnalyticsService} from '@app/services/analytics.service';
import {DataService} from '@app/services/data.service';
import {User} from '#defs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

  user: User;
  constructor(
    private analytics: AnalyticsService,
    private dataService: DataService
  ) {
    this.analytics.zendeskSetup();
    this.user = this.dataService.user;
  }

  ngAfterViewInit(): void {
    // gleap
    if(this.user){
      setTimeout(()=>{
        if(Gleap) {
          const gleapUserIdentity = Gleap.getIdentity();
          Gleap.identify(gleapUserIdentity.gleapId, {
            name: this.user.name,
            email: this.user.email
          }, gleapUserIdentity.gleapHash);
        }
      }, 3000);
    }
  }
}
